import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'

import { I18NService } from 'services'

interface Form {
  email: string
}

export const useForgotPasswordForm = () => {
  const { t } = useTranslation(I18NService.NAMESPACES.COMMON)

  const validationSchema = yup.object().shape({
    email: yup.string().email(t('validations.email')).required(t('validations.required')),
  })

  return useForm<Form>({ resolver: yupResolver(validationSchema) })
}
